<template>
  <InfoWraper>
    <!--<div class="nav-author">
        <a href="/Analytics User Guide.pdf" style="margin-bottom: 5px; font-size: 18px; padding-right: 15px; color: #1f2120;" download> User Guide
        </a>
    </div>-->
    <div class="page-header-actions">
      <a-button size="small" v-if="disConnect" type="primary" v-on:click="xeroconnect1()">
         Connect Bank
      </a-button> 
    </div>
    <!--<div class="page-header-actions" style="margin-left: 10px !important;">
      <a-button size="small" type="primary" v-if="disConnect && !dispLink" >
      <a-popconfirm
        title="Are you sure?"
        ok-text="Yes"
        cancel-text="No"
        @confirm="$emit('open-modal')">
        <span>QBO Connect</span>
      </a-popconfirm>
      </a-button> 
    </div>-->
    <!--<div class="page-header-actions" style="margin-left: 10px !important;">
        <a-button size="small" type="primary" v-if="disConnect"  v-on:click="xerodisconnect()">
         Bulk Disconnect 
        </a-button> 
      </div>-->
      
    <div class="nav-author">
      <sdPopover placement="bottomRight" action="click" >
        <template v-slot:content>
          <UserDropDwon>
            <div class="user-dropdwon">
              <figure class="user-dropdwon__info"> 
                <img
                  v-bind:src="currentuser.profile_pic"
                  alt=""
                  style="height: 50px; width: 50px"
                  v-if="currentuser != null"
                />
                <figcaption>
                  <sdHeading as="h5">{{
                    currentuser.f_name + " " + currentuser.l_name
                  }}</sdHeading>
                  <p>{{ currentuser.email }}</p>
                </figcaption>
              </figure>
              <ul class="user-dropdwon__links">
                <li>
                  <a to="profile" href="profile"> <sdFeatherIcons type="user" /> Profile </a>
                </li>
                <li v-if="dispLink">
                <!--<a to="profile" target="_blank" :href="currentuser.link"> <sdFeatherIcons type="shopping-bag" /> Buy Subscription </a>-->
                <a to="profile" target="_blank" href="https://newanalytics.corientbiz.com/xero-subscription-select/"> <sdFeatherIcons type="shopping-bag" /> Buy Subscription </a>
                </li>
                <!-- <li>
                  <a to="#"> <sdFeatherIcons type="settings" /> Settings </a>
                </li>
                <li>
                  <a to="#"> <sdFeatherIcons type="dollar-sign" /> Billing </a>
                </li>
                <li>
                  <a to="#"> <sdFeatherIcons type="users" /> Activity </a>
                </li>
                <li>
                  <a to="#"> <sdFeatherIcons type="bell" /> Help </a>
                </li> -->
              </ul>
              <a @click="SignOut" class="user-dropdwon__bottomAction" href="#">
                <LogoutOutlined /> Sign Out
              </a>
            </div>
          </UserDropDwon>
        </template>
        <a to="#" class="head-example">
          <a-avatar
            v-if="currentuser != null"
            v-bind:src="API_ENDPOINT + currentuser.profile_pic"
            style="height: 40px; width: 40px"
          />
        </a>
      </sdPopover>
    </div>
  </InfoWraper>
</template>

<script>
/* global Plaid */
import { InfoWraper, UserDropDwon } from "./auth-info-style";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { LogoutOutlined } from "@ant-design/icons-vue";
import { computed, ref, defineComponent, onMounted } from "vue";
import { message, Notification } from "ant-design-vue";
export default defineComponent({
  name: "AuthInfo",
  props: ["currentuser","disConnect","dispLink","dispConnection"],
  emits: ["open-modal"],
  watch: {
    currentuser: function (newVal, oldVal) {
      // watch it
     
    },
  },
  components: {
    InfoWraper,
    UserDropDwon,
    LogoutOutlined,
  },
  data() {
    return {
      flag: "english",
    };
  },
  setup(props) {
    const { dispatch } = useStore();
    const { push } = useRouter();
    const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
    var isConnect = ref(false);
    var publicToken = ref(null);
    onMounted(() => {
    
    });
    const SignOut = (e) => {
      e.preventDefault();
      dispatch("logOut").then(() => {
        push("/auth/login");
      });
    };
    const xeroconnect = () => {
      //window.location.href = API_ENDPOINT + 'xero/authorization.php?app_id=1';
      window.location.href = API_ENDPOINT +"tink-connect?company_id=" + props.currentuser.company_id;
      
    };
    const xeroconnect1 = () => {
      dispatch("connectToTink").then(
        (response) => {
          const linkToken = response.data.link_token;
          const handler = Plaid.create({
            token: linkToken,
            onSuccess: (public_token, metadata) => {
              savePublicToken(public_token);
              //publicToken.value=public_token;
            },
            onExit: (err, metadata) => {
              if (err) {
                console.error(err);
              }
            }
          });
          handler.open();
          Notification.success({
            message: "Connect Link Opened"
          });
        },
        (error) => {
        Notification["error"]({
              message: "Error!",
              description: error.data.msg
            });

        });
    };
    const savePublicToken = (public_token) => {
      //alert(public_token);
      let api_data = [];
      api_data['public_token'] = public_token;
      dispatch("savePublicToken",api_data).then(
        (response) => {
          Notification["success"]({
              message: "Public Token Generated",
          });
          Notification["success"]({
              message: "Access Token Granted",
          });
          Notification["success"]({
              message: "Bank's Connected",
          });
          Notification.success({
            message: "Transaction Saved"
          });
          location.reload(true);
        },
        (error) => {
        Notification["error"]({
              message: "Error!",
              description: error.data.msg
            });

        });
    };
    const xerodisconnect = () => {
      //alert("In DisConnected");
      window.location.href = API_ENDPOINT + 'xero/authorization1.php?app_id=1';
    };

    return {
      SignOut,
      API_ENDPOINT,
      xeroconnect,
      xeroconnect1,
      xerodisconnect,
      isConnect,
      publicToken,
      savePublicToken,
      };
  },
  methods: {
    onFlagChangeHandle: function (value) {
      this.flag = value;
    },
  },
});
</script>
<style scoped>
.custom-switch {
  width: 120px; /* Adjust the width */
  height: 34px; /* Adjust the height */
}
.custom-connect {
  background-color: #52c41a; /* Green color for Connect */
}

.custom-disconnect {
  background-color: #f5222d; /* Red color for Disconnect */
}
.custom-switch.ant-switch::after {
  width: 30px !important; /* Adjust the handle size */
  height: 30px !important; /* Adjust the handle size */
  top: 1px; /* Adjust the position */
  left:1px;
}

.custom-switch.ant-switch-checked.ant-switch::after {
  left: calc(100% - 1px); /* Adjust the handle position when checked */
}

.custom-switch .ant-switch-inner {
  line-height: 34px !important; /* Adjust the inner content alignment */
}
</style>